import { IApplicationState, TBoardId, TKanbanCardProperty } from '../../../../types/types';
import { getBoardDefaultCardPreviewHiddenProperties } from './getBoardDefaultCardPreviewHiddenProperties';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardUserMetaCardPreviewHiddenProperties = (
    state: IApplicationState,
    boardId: TBoardId
): TKanbanCardProperty[] => {
    const userBoardMeta = getBoardUserMeta(state, boardId);
    return userBoardMeta && userBoardMeta.cardPreviewHiddenProperties || getBoardDefaultCardPreviewHiddenProperties(state, boardId);
};
